import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiLock, FiCheck, FiAlertCircle, FiX } = FiIcons;

export default function PasswordSettings({ isOpen, onClose, currentStoredPassword }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (currentPassword !== currentStoredPassword) {
      setStatus({ type: 'error', message: 'La contraseña actual es incorrecta.' });
      return;
    }

    if (newPassword.length < 6) {
      setStatus({ type: 'error', message: 'La nueva contraseña debe tener al menos 6 caracteres.' });
      return;
    }

    if (newPassword !== confirmPassword) {
      setStatus({ type: 'error', message: 'Las contraseñas nuevas no coinciden.' });
      return;
    }

    localStorage.setItem('cb_admin_password', newPassword);
    setStatus({ type: 'success', message: 'Contraseña actualizada correctamente.' });
    
    setTimeout(() => {
      onClose();
      setStatus({ type: '', message: '' });
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }, 2000);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-sm">
      <div className="bg-slate-900 border border-slate-800 rounded-2xl w-full max-w-md p-8 shadow-2xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <SafeIcon icon={FiLock} className="text-blue-500" /> Cambiar Contraseña
          </h2>
          <button onClick={onClose} className="text-slate-500 hover:text-white transition-colors">
            <SafeIcon icon={FiX} className="text-xl" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-400 uppercase mb-2">Contraseña Actual</label>
            <input 
              required
              type="password" 
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="w-full p-3 bg-slate-950 border border-slate-800 rounded-lg text-white outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          
          <div className="pt-2 border-t border-slate-800">
            <label className="block text-xs font-bold text-slate-400 uppercase mb-2">Nueva Contraseña</label>
            <input 
              required
              type="password" 
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full p-3 bg-slate-950 border border-slate-800 rounded-lg text-white outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-slate-400 uppercase mb-2">Confirmar Nueva Contraseña</label>
            <input 
              required
              type="password" 
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full p-3 bg-slate-950 border border-slate-800 rounded-lg text-white outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {status.message && (
            <div className={`p-3 rounded-lg flex items-center gap-2 text-sm ${
              status.type === 'success' ? 'bg-emerald-500/10 text-emerald-500 border border-emerald-500/20' : 'bg-red-500/10 text-red-500 border border-red-500/20'
            }`}>
              <SafeIcon icon={status.type === 'success' ? FiCheck : FiAlertCircle} />
              {status.message}
            </div>
          )}

          <button type="submit" className="w-full py-3 bg-blue-600 hover:bg-blue-500 text-white rounded-lg font-bold transition-all mt-4">
            Guardar Cambios
          </button>
        </form>
      </div>
    </div>
  );
}